import type { CSS } from '@grupoboticario/flora-react'

export const auxTextCss: CSS = {
  color: '$nonInteractiveAuxiliar'
}

export const predominantTextCss: CSS = {
  color: '$nonInteractivePredominant'
}

export const centeredTitleCss: CSS = {
  textAlign: 'center'
}

export const modalWrapperCss: CSS = {
  width: '100%'
}

export const descriptionCss: CSS = {
  marginBottom: '$3'
}
